module.exports = __webpack_public_path__ + "assets/img/DS.2f2d8d31.png";